import React from "react";
import useMarketingDoc from "./useMarketingDoc";

/** Renders `children({ doc, save })` once the section's saved document has loaded (doc is {} if never saved). */
export default function MarketingDocGate({ section, children }) {
  const { status, doc, error, save } = useMarketingDoc(section);
  if (status === "loading") return <div className="text-muted py-4" role="status">Loading…</div>;
  if (status === "error") return <div className="alert alert-danger" role="alert">{error}</div>;
  return children({ doc: doc || {}, save });
}
